import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackFeedbackSubmittedSpec,
  trackFeedbackUpdatedSpec,
  trackSurveySubmittedSpec,
  trackSurveyUpdatedSpec,
  trackSurveyViewedSpec,
  trackUniversalDictationCsatDismissedSpec,
  trackUniversalDictationCsatSubmittedSpec,
  type FeedbackUpdated,
  type SurveySubmitted,
  type SurveyUpdated,
  type SurveyViewed,
  type UniversalDictationCsatDismissed,
  type UniversalDictationCsatSubmitted,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const feedbackEvents: SnowplowEventMap = {
  [TrackingEventName.FeedbackSubmitted]: (props) => {
    const feedback = props as Parameters<typeof trackFeedbackSubmittedSpec>[0];
    if (feedback.target_type === 'dictation') {
      // The current Iglu schema has these fields. Cohort and language fields
      // remain in Amplitude until they are added to the Snowplow schema.
      trackFeedbackSubmittedSpec({
        type: feedback.type,
        value: feedback.value,
        target_type: feedback.target_type,
        target_id: feedback.target_id,
        source: feedback.source,
        rating: feedback.rating,
        feedback_rating_reasons: feedback.feedback_rating_reasons,
        has_feedback_text: feedback.has_feedback_text,
      });
      return;
    }
    trackFeedbackSubmittedSpec(feedback);
  },
  [TrackingEventName.FeedbackUpdated]: (props) =>
    trackFeedbackUpdatedSpec(props as FeedbackUpdated),
  [TrackingEventName.SurveyViewed]: (props) =>
    trackSurveyViewedSpec(props as SurveyViewed),
  [TrackingEventName.SurveySubmitted]: (props) =>
    trackSurveySubmittedSpec(props as SurveySubmitted),
  [TrackingEventName.SurveyUpdated]: (props) =>
    trackSurveyUpdatedSpec(props as SurveyUpdated),
  [TrackingEventName.DictationCsatDismissed]: (props) =>
    trackUniversalDictationCsatDismissedSpec(props as UniversalDictationCsatDismissed),
  [TrackingEventName.DictationCsatSubmitted]: (props) =>
    trackUniversalDictationCsatSubmittedSpec(props as UniversalDictationCsatSubmitted),
};
